import dynamic from "next/dynamic";

export const JobCardV2 = dynamic(() => import("./component"));
